import { cx } from "@linaria/core";
import type React from "react";
import type { ComponentProps } from "react";
import Markdown, { type ExtraProps } from "react-markdown";
import rehypeRaw from 'rehype-raw';
import remarkBreaks from "remark-breaks";
import remarkGFM from 'remark-gfm';
import { CodeBlock } from "./code-block/CodeBlock";
import { codeBlockLanguages } from "./code-block/StarryNightInstance";
import { Link } from "./Link";
import "./Markdown.linaria.module.css!=!./Markdown?./Markdown.linaria.module.css?css=H4sIAAAAAAAAA5VT7Y7aMBD836ew7nQSiCZ1nIDAkXgXJ3awhbEtZ+mFonv3yvkAAuFKlR+Qze7szuxsfOAyW244AlZocT4wv1OGksw1aOWavLCeCx/VjpXK7CjuA5S4BtVWK47e0zTNv+IRDJWsnoEUjM/PPQJYR4014j4VAf95H5FnxzgP/VauQUl6meMfbRH4c8HK/c7bo+FRabX19D1ZhYexiWxqQEalVJrPiJlP1BJCJuoCsXGvJ9S6RDk1VJKUg7iFBbCH6FNxkDS7ig7W3QSjT1HsFUQBi3vrokppEJ4W+uhnmWvm+fMvztYKlDV0AKlBlfvTNd6/hyVt8DSPBRSWn7bgaaV8DZGtIjg5sQX+zYqPelhlpEUFFI++oa1Wg+NwvPTigHA+yideHK5TeqEZqN8i16oOHE5aPDYMoJQWorJenP9EynDRUJKX1oAwQN/Q2xWQFbXVRxA5V7XT7EQLbct97tVOAi2ZLmcJxh8oQjjOtGx/w5TzVigck0zLXIo2G8dkqWXe7at/6U2bXk27Xq+H7XrG1bGmS/yRP9gDPDO1Y14YmODGKhD+Qi35L2rd4Cus5QTLcG0Dx+5PME9PcCxHGvRYXPToaLeH+mD1lIfnkYdmNXTHN1AaiEzv1FiY3RTNQ1yrsb/S4JcXKy8meb7upKf3MmLHI4jcwsXZRkv0CxG0QNmNluGeJ7tu2rbLmz0M2raJ6bAY0qpPAuSrsz2XO/jmHqUr6iW+ObdS+VKL/OvHX6veSiE4BgAA"
export function UnsafeMarkdown({
  md,
  ...divProps
}: {
  readonly md: string;
} & Record<`data-${string}`, string | boolean> & React.JSX.IntrinsicElements['div']): React.ReactElement {
  return <div {...divProps} className={cx(markdownCssClass, divProps.className)} data-is-md=''><Markdown unwrapDisallowed skipHtml={false} remarkPlugins={[remarkBreaks, remarkGFM]} components={{
      a: Link as any,
      pre: MarkdownCodeBlock
    }} remarkRehypeOptions={{
      clobberPrefix: 'md-',
      allowDangerousHtml: true
    }} rehypePlugins={[rehypeRaw
    // If we had user-submitted Markdown, we'd use rehype-sanitize here,
    // but all content for this project is all controlled by a trusted source.
    ]}>
		{md}
	</Markdown></div>;
}
const markdownCssClass = "mdh459d";
function MarkdownCodeBlock({
  children,
  node,
  ...props
}: ComponentProps<'pre'> & ExtraProps): React.ReactElement {
  if (!node) throw new Error('MarkdownCodeBlock: No `node` prop provided! This is almost certainly a bug in the WikiMarkdown component.');
  const codeElement = node.children[0];
  if (!codeElement || codeElement.type !== 'element' || codeElement.tagName !== 'code') throw new Error('MarkdownCodeBlock: Expected the first child of the <pre> element to be a <code> element.');
  const className = Array.isArray(codeElement.properties.className) ? codeElement.properties.className.join(' ') : codeElement.properties.className;
  if (!className) return <pre {...props}>{children}</pre>;
  if (typeof className !== 'string') throw new Error(`MarkdownCodeBlock: Expected the \`className\` property of the <code> element to be a string or an array of strings, but got ${typeof className}.`);
  const language = className.match(/(?:\s*|^)language-(?<language>\w+)/u)?.groups?.language;
  const code = codeElement.children.map(child => {
    if (child.type === 'text') return child.value;
    if (child.type === 'element' && child.tagName === 'br') return '\n';
    throw new Error(`MarkdownCodeBlock: Unexpected child type in <code> element: ${child.type}. Expected 'text' or 'br'.`);
  }).join('');
  const languageCode = `source.${language}`;
  if (codeBlockLanguages.has(languageCode)) return <CodeBlock language={languageCode} code={code} doLineNumbers />;else return <pre {...props}>{children}</pre>;
}